import React from 'react';

import Info from '@/components/icons/Info';
import type { CalorieKey } from '@/utils/constants';

interface NutritionalInfoProps {
  dailyNutrition: {
    cal: string;
    p: string;
    c: string;
    f: string;
  };
  showToolTip?: boolean;
  handleClick?: () => void;
  calorieKey: CalorieKey;
}

interface NutritionalItemProps {
  label: string;
  value: string;
  hasBorderRight?: boolean;
  showToolTip?: boolean;
  handleClick?: () => void;
  calorieKey?: CalorieKey;
}

const NutritionalItem: React.FC<NutritionalItemProps> = ({
  label,
  value,
  hasBorderRight,
  showToolTip,
  handleClick,
  calorieKey,
}) => {
  const renderContent = () => {
    if (showToolTip && handleClick) {
      const isAboveThreshold = calorieKey === 'aboveThreshold';
      const iconColor = isAboveThreshold ? '#BB5A00' : '#006CED';
      const buttonColor = isAboveThreshold ? 'text-caution' : 'font-interBold';

      return (
        <button
          onClick={handleClick}
          className={`font-interMedium text-lg leading-4 ${buttonColor}`}
        >
          <div className="flex items-center space-x-1">
            <div>
              {value} <span className="font-inter">{label}</span>
            </div>
            <Info color={iconColor} />
          </div>
        </button>
      );
    }

    return (
      <span
        className={`${
          hasBorderRight
            ? 'font-interBold text-lg'
            : 'font-interMedium text-base'
        } leading-4 text-rhubarb-dark md:text-black`}
      >
        {value} <span className="font-inter">{label}</span>
      </span>
    );
  };

  return (
    <div
      className={`my-3 flex items-center px-2 ${
        hasBorderRight ? 'border-r-2 border-grey' : ''
      }`}
    >
      {renderContent()}
    </div>
  );
};

const NutritionalInfo: React.FC<NutritionalInfoProps> = ({
  dailyNutrition,
  showToolTip,
  handleClick,
  calorieKey,
}) => {
  return (
    <div className="flex w-full flex-row justify-center rounded-3xl bg-rhubarb-lite md:w-auto md:justify-start md:rounded-none md:bg-transparent">
      <NutritionalItem
        label="CAL"
        value={Number(dailyNutrition.cal)?.toFixed(0)}
        hasBorderRight
        showToolTip={showToolTip}
        handleClick={handleClick}
        calorieKey={calorieKey}
      />
      <NutritionalItem label="P" value={Number(dailyNutrition.p)?.toFixed(0)} />
      <NutritionalItem label="C" value={Number(dailyNutrition.c)?.toFixed(0)} />
      <NutritionalItem label="F" value={Number(dailyNutrition.f)?.toFixed(0)} />
    </div>
  );
};

export default NutritionalInfo;
